import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { cardsService, LockCardRequest } from '@aslanpay/portal-common-lib';

const useLockCard = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, LockCardRequest>) => {
  return useMutation<unknown, Error, LockCardRequest>(
    ({ id }: LockCardRequest) =>
      cardsService.lockCard({
        id,
      }),
    { onSuccess, onError }
  );
};

export default useLockCard;
